/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import StoneFornaxEvaluationService from '@adp-arch/idl/stone_fornax_evaluation';

import { axiosInstance, type BotAPIRequestConfig } from './axios';

// eslint-disable-next-line @typescript-eslint/naming-convention -- what can I say
export const StoneEvaluationApi =
  new StoneFornaxEvaluationService<BotAPIRequestConfig>({
    request: (params, config = {}) =>
      axiosInstance.request({
        ...params,
        ...{
          ...config,
          headers: Object.assign(config.headers || {}, {
            'Agw-Js-Conv': 'str',
          }),
        },
      }),
  });
